export default __webpack_public_path__ + "static/mh025-hero-b395b2f0094f2ad7a173da345de8d0a3.jpg";